import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================


export const getAllPageSections = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-section/list`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page sections not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getAllPages = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/page-section/pages`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Pages not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


// ===============================================================================
// =================================== UPDATE API ===================================
// ===============================================================================


export const updatePageSections = async (page_id, data, dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/page-section/update/${page_id}`, data)
        .then((res) => {
            toastMessage("Page sections assigned successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Page sections not assigned", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};